import React from "react";
import SettingsModal from "../../Components/settings/SettingsModal";
const PrivacyPolicy = () => {
  return (
    <div className="page">
      <div className="settings-container">
        <h2 className="settings-page-title">Privacy Policy</h2>

        <SettingsModal />
      </div>
    </div>
  );
};
export default PrivacyPolicy;
